const Image = (): JSX.Element => (
  <svg
    className="home-page-logo"
    width="750"
    height="621"
    viewBox="0 0 750 621"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Logo</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M607.016 103.705C607.016 149.005 581.188 179.977 548.963 200.447C549.024 200.566 549.107 200.876 549.236 201.353L549.236 201.354C550.232 205.048 553.933 218.773 570.946 231.958C573.187 233.694 567.933 235.94 561.248 238.797C548.505 244.242 530.561 251.911 549.403 262.518C684.671 338.669 733.768 455.859 643.089 554.094C570.946 632.249 -42.3217 715.335 2.32109 334.16C21.2564 172.483 33.5856 187.051 69.2504 229.193C94.9214 259.526 132.683 304.145 193.7 307.607C213.972 308.757 237.957 305.988 262.767 303.123C324.409 296.006 391.139 288.301 418.644 338.669C422.037 344.881 452.211 345.182 418.644 311.615C417.82 310.791 416.555 309.578 414.925 308.015L414.921 308.012C400.419 294.11 356.988 252.476 336.666 209.046C328.699 196.246 324.959 177.268 324.959 149.137C324.959 66.1307 392.249 0 475.256 0C558.263 0 607.016 53.105 607.016 103.705ZM532.369 132.261C546.757 132.261 558.421 120.597 558.421 106.21C558.421 91.8217 546.757 80.1581 532.369 80.1581C517.981 80.1581 506.318 91.8217 506.318 106.21C506.318 120.597 517.981 132.261 532.369 132.261Z"
      fill="currentColor"
    />
    <path
      d="M716.733 182.36C671.36 208.283 617.537 197.891 594.491 188.874C574.452 208.912 568.946 207.907 569.442 208.411C598.5 239.974 697.195 224.443 716.733 201.397C727.351 188.873 723.747 178.352 716.733 182.36Z"
      fill="currentColor"
    />
    <path
      d="M711.223 107.212C681.408 133.185 638.078 120.739 622.547 107.212C617.036 160.818 606.015 166.83 603.51 172.841C622.547 183.362 668.568 190.582 710.221 166.83C770.84 132.261 754.809 66.1306 711.223 107.212Z"
      fill="currentColor"
    />
  </svg>
)

export default Image
